<main>
	<router-outlet></router-outlet>
</main>



// WEBPACK FOOTER //
// ./src/app/app.html